<div class="main">
  <div class="row mt-3">
    <div class="col-3">
      <div class="card-hold blue-g d-flex flex-column">
        <div>
          <span class="value">{{ summary.total_alerts }}</span>
        </div>
        <div>
          <span class="title-des">Total Number Of Alerts</span>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div
        (click)="showHighAlerts()"
        class="card-hold red-g d-flex flex-column cursor"
        [class.active-summary]="selectedSeverity == 'high'"
      >
        <div>
          <span class="value">{{ summary.high_alerts }}</span>
        </div>
        <div>
          <span class="title-des">High Alerts</span>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div
        (click)="showMediumAlerts()"
        class="card-hold orange-g d-flex flex-column cursor"
        [class.active-summary]="selectedSeverity == 'medium'"
      >
        <div>
          <span class="value">{{ summary.medium_alerts }}</span>
        </div>
        <div>
          <span class="title-des">Medium Alerts</span>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div
        (click)="showLowAlerts()"
        class="card-hold green-g d-flex flex-column cursor"
        [class.active-summary]="selectedSeverity == 'low'"
      >
        <div>
          <span class="value">{{ summary.low_alerts }}</span>
        </div>
        <div>
          <span class="title-des">Low Alerts</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row opt-row">
    <div class="col-12 opt-col">
      <div class="d-flex opt-col2">
        <div
          *ngFor="let category of categories"
          class="opt-hold"
          [class.active-tab]="activeCategory == category"
          (click)="selectCategory(category)"
        >
          {{ category }}
        </div>
      </div>
      <div class="d-flex align-items-center">
        <span class="button_Schedule_12">BETA</span>
        <div class="info">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <span class="info-text">
            Data will get purged automatically after 30 days
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row margintop-20">
    <div class="col-12 df">
      <div class="search">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input
          class="text-search"
          type="text"
          placeholder="Search"
          [(ngModel)]="searchKeyword"
          (input)="onSearchInput()"
        />
      </div>
      <div class="d-flex">
        <div class="search3 mar-r-20 cursor" (click)="refresh()">
          <div class="touch d-flex justify-content-between">
            <span class="search-text2">Refresh</span>
            <i class="fa-solid fa-arrows-rotate mt search-text2"></i>
          </div>
        </div>

        <div class="search2">
          <div (click)="toggleSeverityFilter()" class="touch d-flex justify-content-between">
            <span class="search-text">Filter</span>
            <i
              [ngClass]="{ 'rotate-icon': showSeverityFilter, 'rotate-icon0': !showSeverityFilter }"
              class="fa-solid fa-angle-down mt"
            ></i>
          </div>
          <div *ngIf="showSeverityFilter" class="oppt-values">
            <span (click)="setSeverityFilter('all')" class="optv">
              <span>All Alerts</span>
              <i class="fa-solid fa-check" *ngIf="selectedSeverity == 'all'"></i>
            </span>
            <span (click)="setSeverityFilter('high')" class="optv">
              <span>High/Critical</span>
              <i class="fa-solid fa-check" *ngIf="selectedSeverity == 'high'"></i>
            </span>
            <span (click)="setSeverityFilter('medium')" class="optv">
              <span>Medium</span>
              <i class="fa-solid fa-check" *ngIf="selectedSeverity == 'medium'"></i>
            </span>
            <span (click)="setSeverityFilter('low')" class="optv">
              <span>Low</span>
              <i class="fa-solid fa-check" *ngIf="selectedSeverity == 'low'"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <div class="alert alert-danger" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <table class="table table-responsive table-hover" *ngIf="!loading && !errorMessage">
        <thead>
          <tr>
            <th scope="col" *ngFor="let column of currentColumns">{{ column.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedAlerts">
            <td *ngFor="let column of currentColumns">
              <ng-container [ngSwitch]="column.key">
                <span *ngSwitchCase="'criticality'" class="badge" [ngClass]="severityClass(item)">
                  {{ getCellValue(item, column.key) }}
                </span>
                <span *ngSwitchDefault>{{ getCellValue(item, column.key) }}</span>
              </ng-container>
            </td>
          </tr>
          <tr *ngIf="filteredAlerts.length == 0">
            <td [attr.colspan]="currentColumns.length" class="text-center">
              No {{ activeCategory }} Alerts Found!
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-end" *ngIf="!loading && !errorMessage && filteredAlerts.length > 0">
        <nav>
          <ul class="pagination">
            <li class="page-item" [class.disabled]="currentPage == 1">
              <a class="page-link" (click)="navigateToPreviousPage()">Previous</a>
            </li>
            <ng-container *ngFor="let page of getPageNumbers()">
              <li class="page-item" *ngIf="page == '...' else notEllipsis">
                <a class="page-link" (click)="navigateToPage(page)">{{ page }}</a>
              </li>
              <ng-template #notEllipsis>
                <li class="page-item" [class.active]="currentPage == page">
                  <a class="page-link" (click)="navigateToPage(page)">{{ page }}</a>
                </li>
              </ng-template>
            </ng-container>
            <li class="page-item" [class.disabled]="currentPage == totalPages">
              <a class="page-link" (click)="navigateToNextPage()">Next</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
